import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios'

import router from '../router'


import auth from './modules/auth/auth'
import supplier from './modules/supplier/supplier'
import bons from './modules/bons/bons'
import offres from './modules/offres/offres'

Vue.use(Vuex)

export const store = new Vuex.Store({
    plugins: [createPersistedState()],


    //STATE
    state:{
        baseurl:'',
        app_url:'',
        fields:{},
        files:{},
        pays:[],
        messages:[],
        otherfiles:[],
        typeFournisseurs:[],
        file_rules:{},
        activites:[],
        settings:{},
        after_login_files:false,
        after_login_otherfiles:false,
        after_login_messages:false,
        fournisseur:{
        
        }
    },



    //GETTERS
    getters:{
        fields:(state)=>state.fields,
        isComplete : (state) => {
            console.log('rootState',state)
            return state.fournisseur.etape == "complete"
        }
    },

    //MUTATIONS
    mutations:{
        init_after_login_files:(state)=>{
            state.after_login_files = false
        },
        init_after_login_otherfiles:(state)=>{
            state.after_login_otherfiles = false
        },
        init_after_login_messages:(state)=>{
            state.after_login_messages = false
        },
        fields:(state,fields)=>{
            fields.forEach(field => {
                let row={}
                row['required'] = field.obligatoire_yn == "Y" ? true:false
                row['message'] = "Champs requis"
                row['trigger'] = "change"

                state.fields[field.champs] = [row]
                
            });
            // state.fields = fields
        },
        files:(state,params) => {
            // console
            console.log('params',params)
            params.forEach(param => {   
                let paramArr = []
                let row = {}
                // row['id'] = param.id
                for(let doc in param.documents){
                    row["name"] = param.documents[doc].nom_fichier
                    row['url'] = param.documents[doc].chemin_doc
                    paramArr.push(row)
                }
                state.files[param.libelle] = paramArr
                state.files[param.libelle+'_id'] = param.sync_id



                let frow={}
                frow['required'] = param.obligatoire_yn == "Y" ? true:false
                frow['message'] = "Document requis"
                frow['trigger'] = "change"
                frow['libelle'] = param.libelle
                frow['description'] = param.description

                state.file_rules[param.libelle] = [frow]
                
            });
            console.log('for_reload files',[state.otherfiles,state.files,state.messages]
            )
            state.after_login_files = true
            if(state.after_login_files && state.after_login_otherfiles && state.after_login_messages) {
                state.after_login_files = false
                window.location.reload()
            }

        },
        otherfiles:(state,otherfiles) => {
            otherfiles.forEach(ofile => {   
                let row = {}
                // row['id'] = param.id
                row["name"] = ofile.libelle
                row['url'] = ofile.chemin_doc
                state.otherfiles.push(row)
            });
            console.log('for_reload otherfiles',[state.otherfiles,state.files,state.messages])
            state.after_login_otherfiles = true
            if(state.after_login_files && state.after_login_otherfiles && state.after_login_messages) {
                state.after_login_otherfiles = false
                window.location.reload()
            }


        },
        logout:(state) => {
            // state.fields = {}
            state.files={}
            // state.pays=[]
            state.fournisseur={}
            state.otherfiles=[]
            // state.file_rules={}
        },
        fournisseur:(state, fournisseur) => {
            state.fournisseur = fournisseur
        },
        pays:(state,pays) => {
            state.pays = pays
        },
        messages:(state,messages) => {
            state.messages = messages
            console.log('messages',[state.otherfiles,state.files,state.messages])
            state.after_login_messages = true
            if(state.after_login_files && state.after_login_otherfiles && state.after_login_messages) {
                state.after_login_otherfiles = false
                window.location.reload()
            }

        },
        activites:(state,activites) => {
            state.activites = activites
        },
        typeFournisseurs:(state, typeFournisseurs)=>{
            state.typeFournisseurs = typeFournisseurs
        },
        settings:(state,settings)=>{
            state.settings = settings
        },
        configs:(state,configs)=>{
            state.baseurl = configs.baseurl;
            state.app_url = configs.app_url;
            console.log('url set ');
        }


    },


    //ACTIONS
    actions:{
        getFields:({commit,state})=>{

            axios.get(state.baseurl+'/fields',{
                headers:{
                    "Content-Type":"applicatoin/json",
                }
            })
                .then(fields=>{
                    console.log('fields',fields)
                    commit('fields', fields.data.data)
                })
                .catch(error=>{
                    console.log(error)
                })
        },
        logout:({commit}) => {
            localStorage.removeItem('vuex')
            commit('logout')
            commit('onLogout')
            router.push('/pages/login')
       },

       getFiles:({commit,state}) => {
        axios.get(state.baseurl+'/paramdocuments/getfiles/'+state.fournisseur.sync_id,{
            headers:{
                "Content-Type":"application/json",
                "Authorization":"Bearer "+state.auth.token
            }
        })
            .then(files=>{
                console.log('files',files)
                commit('files', files.data.data)
            })
            .catch(error=>{
                console.log(error)
            })
       },
       getOtherFiles:({commit,state}) => {
        axios.get(state.baseurl+'/autredocuments/byfournisseur/'+state.fournisseur.sync_id,{
            headers:{
                "Content-Type":"application/json",
                "Authorization":"Bearer "+state.auth.token
            }
        })
            .then(otherfiles=>{
                console.log('otherfiles',otherfiles)
                commit('otherfiles', otherfiles.data.data)
            })
            .catch(error=>{
                console.log(error)
            })
       },

       updateFournisseur:({commit,state}) => {
        //    let frns = state.fournisseur
        //    hp.boolToChar(frns)
        //    console.log('modFrn', frns)
        //    return true;
        //    console.log('state Fournisseur', state.fournisseur)
        //    let frns = state.fournisseur
        //    delete frns.created_at
        //    delete frns.updated_at
        axios.put(state.baseurl+'/fournisseurs/'+state.fournisseur.id,state.fournisseur,{
            headers:{
                "Content-Type":"application/json",
                "Authorization":"Bearer "+state.auth.token
            }
        })
            .then(fournisseur=>{
                console.log('newFournisseur',fournisseur)
                commit('fournisseur', fournisseur.data.data)
            })
            .catch(error=>{
                console.log(error)
            })
       },
       getPays:({commit,state}) => {
        axios.get(state.baseurl+'/pays',{
            headers:{
                "Content-Type":"application/json",
            }
        })
            .then(pays=>{
                console.log('pays',pays)
                commit('pays', pays.data.data)
            })
            .catch(error=>{
                console.log(error)
            })
       },

       getMessages:({commit, state}) => {
        axios.get(state.baseurl+'/users/messages/'+state.fournisseur.id,{
            headers:{
                "Content-Type":"application/json",
                "Authorization":"Bearer "+state.auth.token
            }
        })
            .then(messages=>{
                console.log('messages',messages)
                commit('messages', messages.data.data)
            })
            .catch(error=>{
                console.log(error)
            })
       },

       activites:({commit, state}) => {
        axios.get(state.baseurl+'/activites',{
            headers:{
                "Content-Type":"application/json",
            }
        })
            .then(activites=>{
                console.log('activites',activites)
                commit('activites', activites.data.data)
            })
            .catch(error=>{
                console.log(error)
            })
       },

       typeFournisseurs:({commit, state}) => {
        axios.get(state.baseurl+'/typefournisseurs',{
            headers:{
                "Content-Type":"application/json",
            }
        })
            .then(typef=>{
                console.log('typeF',typef)
                commit('typeFournisseurs', typef.data.data)
            })
            .catch(error=>{
                console.log(error)
            })
       },

       settings:({commit,state}) => {
        axios.get(state.baseurl+'/settings',{
            headers:{
                "Content-Type":"application/json",
            }
        })
            .then(settings=>{
                console.log('settings',settings)
                commit('settings', settings.data.data)
            })
            .catch(error=>{
                console.log(error)
            })
       },
       configs:({commit})=>{
        axios.get('/config/config.json').then((res)=>{
            commit('configs',res.data);
        }).catch(()=>{
            console.log('Erreur');
        });
       
    },
    
    },

    modules:{
        auth,
        supplier,
        bons,
        offres
    },
 
})